export default __webpack_public_path__ + "assets/a5a2aac51e561d3c180c441a059ae7b7.jpeg";